export const BASE_URL = 'https://wallet-goit.onrender.com/api';
